export const toStringValue = (value, fallback = '') => {
    if (value === null || value === undefined) {
        return fallback;
    }

    return String(value).trim();
};

export const toNumberValue = (value, fallback = 0) => {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : fallback;
};

export const toNullableNumber = (value) => {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
};

export const toTimestamp = (value) => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    if (typeof value === 'number' && Number.isFinite(value)) {
        return value > 10000000000 ? value : value * 1000;
    }

    const normalizedValue = String(value).trim();
    const parsedNumber = Number(normalizedValue);

    if (normalizedValue && Number.isFinite(parsedNumber)) {
        return parsedNumber > 10000000000 ? parsedNumber : parsedNumber * 1000;
    }

    const parsedDate = Date.parse(normalizedValue);

    return Number.isFinite(parsedDate) ? parsedDate : null;
};

export const formatDateLabel = (value) => {
    const timestamp = toTimestamp(value);

    if (!timestamp) {
        return '';
    }

    return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(timestamp);
};

export const formatNumberLabel = (value, options = {}) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const parsed = Number(value);

    if (!Number.isFinite(parsed)) {
        return '';
    }

    const maximumFractionDigits = Math.min(2, Math.max(0, Number(options.maximumFractionDigits ?? 2)));
    const minimumFractionDigits = Math.min(maximumFractionDigits, Math.max(0, Number(options.minimumFractionDigits ?? 0)));

    return new Intl.NumberFormat('es-ES', {
        useGrouping: true,
        minimumFractionDigits,
        maximumFractionDigits
    }).format(parsed);
};

export const toBoolean = (value, fallback = false) => {
    if (value === null || value === undefined || value === '') {
        return fallback;
    }

    if (typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'number') {
        return value === 1;
    }

    const normalized = String(value).trim().toLowerCase();

    if (['1', 'true', 'yes', 'si'].includes(normalized)) {
        return true;
    }

    if (['0', 'false', 'no'].includes(normalized)) {
        return false;
    }

    return fallback;
};

export const toArray = (value) => {
    if (Array.isArray(value)) {
        return value;
    }

    if (value && typeof value === 'object') {
        return Object.values(value);
    }

    return [];
};

export const decodeFinderName = (value) => toStringValue(value).replaceAll('Q1SPACEQ1', ' ');

export const normalizeFinderSelection = (value) =>
    toArray(value)
        .map((item) => toStringValue(item))
        .filter((item) => item && item !== '0');

export const formatPercent = (value, digits = 1) => {
    const normalizedDigits = Math.min(2, Math.max(0, Number(digits) || 0));
    const formatted = formatNumberLabel(value, {
        minimumFractionDigits: normalizedDigits,
        maximumFractionDigits: normalizedDigits
    });

    return formatted ? `${formatted}%` : '';
};
